import { useL10n } from "@ews/react-localization-context";
import { IonButton, IonHeader, IonList, IonModal, IonTitle, IonToolbar, useIonRouter } from "@ionic/react";
import React, { useEffect, useRef, useState } from "react";
import { useNamedRoutes } from "../../NamedRoutes";

import
{
    useCreateCustomer
} from "../../ReactData/customer";

import { IonModalCustomEvent, OverlayEventDetail } from "@ionic/core";
import { useIsMobile } from "../../Responsive";
import SettingsTextInput from "../../Settings/SettingsComponents/SettingsTextInput/SettingsTextInput";
import CustomerTypeAhead from "../CustomerTypeAhead";
import modalStyle from "./NewCustomerModal.module.scss";
import { NewCustomerModalProps } from "./types";
import { useMyProfile } from "../../Login/LoginProvider";

const NewCustomerModal: React.FC<NewCustomerModalProps> = ({ trigger, onDismiss, parentId }) =>
{

    const mobileView = useIsMobile();
    const { translate: t } = useL10n();
    const modal = useRef<HTMLIonModalElement>(null);
    const [name, setName] = useState<string | null>(null);
    const [selectedParentId, setSelectedParentId] = useState<string | undefined>(parentId);
    const { generate } = useNamedRoutes();
    const router = useIonRouter();
    const createCustomer = useCreateCustomer();
    const me = useMyProfile();

    async function confirm(name: string | null)
    {
        if (!name) return;

        try {

            const customer = await createCustomer(name, selectedParentId);

            const id = customer.id;
            modal.current?.dismiss();
            const link = generate('customer', { id });
            router.push(link);

        } catch (err) {
            console.log(err);
        }
    }

    useEffect(() =>
    {
        if (!parentId && me.customerId) setSelectedParentId(me.customerId);
    }, [parentId, me]);

    function onWillDismiss(event: IonModalCustomEvent<OverlayEventDetail<any>>)
    {
        setName(null);
        onDismiss && onDismiss(event);
    }

    return <IonModal
        ref={modal}
        className={modalStyle.newSystemModal}
        trigger={trigger}
        breakpoints={mobileView ? [.6] : undefined}
        onWillDismiss={onWillDismiss}>
        <IonHeader>
            <IonToolbar>
                <div className={`${modalStyle.titleCenter}`}>
                    <IonTitle>{`${t("COM_BANNERS_NEW_CLIENT")}`}</IonTitle>
                </div>
            </IonToolbar>
        </IonHeader>
        <IonList
            className="ion-padding"
            color="primary">
            <SettingsTextInput
                text={"COM_FACPMANAGEMENT_CUSTOMERS_NAME"}
                value={name || undefined}
                onChange={(value: string) =>
                {
                    const name: string | null = value === "" ? null : value;
                    setName(name);
                }} />


            <CustomerTypeAhead
                id="new-customer-modal"
                label="COM_FACPMANAGEMENT_CUSTOMER_FIELD_PARENT_LABEL"
                currentId={selectedParentId || ""}
                onChange={(parentId) =>
                {
                    setSelectedParentId(parentId || undefined);
                }}
            />
        </IonList>
        <div className={`${modalStyle.buttonContainer} ${modalStyle.marginBottom}`}>
            <IonButton
                slot="start"
                color={"danger"}
                onClick={() => modal.current?.dismiss()}>{t("COM_BANNERS_CANCEL")}</IonButton>
            <IonButton
                disabled={!name}
                slot="end"
                color={"success"}
                onClick={() => confirm(name)}>
                {t("COM_CONTENT_FORM_VIEW_DEFAULT_OPTION")}
            </IonButton>
        </div>
    </IonModal>;

};


export default NewCustomerModal;
